import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TestCenterIcon from 'assets/svgs/testCenterIcon.svg';
import EventIcon from 'assets/svgs/eventIcon.svg';
import BuildingIcon from 'assets/svgs/buildingIcon.svg';
import './EventDetails.scss';

const EventDetails = ({tcCycleName, testingEventName, locationName, locationArea, displayTC}) => (
  <div className="event-details-section">
    {displayTC && <div> <TestCenterIcon/> {tcCycleName}</div>}
    {
      locationName &&
      (<div><BuildingIcon/> {locationName}{locationArea && locationArea.length > 0 && `, ${locationArea}`}</div>)
    }
    {
      testingEventName &&
      (<div> <EventIcon/> {testingEventName}</div>)
    }
  </div>
);

export default EventDetails;

EventDetails.propTypes = {
  displayTC: PropTypes.bool,
  tcCycleName: PropTypes.string,
  testingEventName: PropTypes.string,
  locationName: PropTypes.string,
  locationArea: PropTypes.string,
};

EventDetails.defaultProps = {
  displayTC: true,
};
